var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 132 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1.048 23.747a1.482 1.482 0 0 1 0-2.095l8.381-8.382a1.482 1.482 0 0 1 2.095 0l8.382 8.382a1.482 1.482 0 0 1 0 2.095l-8.382 8.382a1.482 1.482 0 0 1-2.095 0l-8.381-8.382Z",
  fill: "url(#logo_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.017 13.27a1.482 1.482 0 0 1 0-2.095l8.38-8.381a1.482 1.482 0 0 1 2.096 0l9.43 9.429 9.428 9.429a1.481 1.481 0 0 1 0 2.095l-9.429 9.43-9.429 9.428a1.482 1.482 0 0 1-2.095 0l-8.381-8.381a1.482 1.482 0 0 1 0-2.095l8.38-8.382a1.482 1.482 0 0 0 0-2.095l-8.38-8.382Z",
  fill: "url(#logo_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M53.794 22.67c0-1.561.257-2.993.77-4.297a9.936 9.936 0 0 1 2.253-3.378c.968-.948 2.133-1.68 3.496-2.193 1.363-.533 2.894-.8 4.593-.8 1.66 0 3.17.247 4.534.74 1.383.495 2.558 1.206 3.526 2.134.968.909 1.719 2.025 2.252 3.349.534 1.323.8 2.825.8 4.504 0 1.56-.266 2.993-.8 4.297a9.585 9.585 0 0 1-2.222 3.378c-.968.948-2.143 1.689-3.526 2.222-1.363.514-2.885.77-4.564.77-1.66 0-3.18-.236-4.563-.71-1.363-.494-2.529-1.196-3.497-2.104-.968-.929-1.718-2.055-2.252-3.379-.533-1.343-.8-2.854-.8-4.533Zm3.912.03a8.94 8.94 0 0 0 .444 2.844c.316.889.78 1.66 1.393 2.311.612.652 1.363 1.176 2.252 1.57.909.376 1.956.564 3.14.564 1.107 0 2.095-.178 2.964-.534.89-.355 1.64-.849 2.252-1.481a6.356 6.356 0 0 0 1.452-2.282c.336-.909.504-1.906.504-2.993a8.43 8.43 0 0 0-.474-2.844 6.187 6.187 0 0 0-1.363-2.312c-.613-.652-1.373-1.165-2.282-1.54-.889-.396-1.926-.593-3.111-.593-1.107 0-2.104.178-2.993.533-.89.356-1.65.86-2.282 1.511a6.57 6.57 0 0 0-1.422 2.282c-.316.889-.474 1.877-.474 2.963ZM91.014 26.61v6.46H87.31V12.329h6.904c3.28 0 5.65.593 7.112 1.778 1.482 1.165 2.223 2.914 2.223 5.245 0 2.43-.79 4.247-2.371 5.452-1.58 1.205-3.901 1.808-6.963 1.808h-3.2Zm0-10.874v7.467h3.467c1.739 0 3.042-.296 3.912-.889.869-.612 1.303-1.63 1.303-3.052 0-1.284-.404-2.193-1.215-2.726-.81-.534-2.123-.8-3.94-.8h-3.527ZM112.828 29.663c.296-.711.563-1.492.8-2.341.257-.85.474-1.798.652-2.845.197-1.067.355-2.242.474-3.526.118-1.304.188-2.746.207-4.326l.06-4.297H129.6v17.335h2.4v7.26h-3.467V33.07h-14.49v3.852h-3.467v-7.26h2.252Zm5.571-12.95c-.119 5.374-.771 9.69-1.956 12.95h9.453V15.736h-7.497v.977Z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__a",
  x1: 5.238,
  y1: 17.461,
  x2: 19.731,
  y2: 31.954,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#48A3ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.863,
  stopColor: "#07456F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "logo_svg__b",
  x1: 23.311,
  y1: 2.881,
  x2: 25.584,
  y2: 43.589,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#009F9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1F4949"
})))));
export default SvgLogo;